import * as v from 'valibot'
import { MotnTvShowSchema } from './motn-tv-show.format'
import { MotnVodSchema } from './motn-vod.format'

/** Single search hit: VOD or TV show (discriminated by `contentType`). */
export const HybridSearchItemSchema = v.union([MotnVodSchema, MotnTvShowSchema])

/** Payload of GET /v3/movienight/search — flat list of MOTN items. */
export const MotnSearchResultSchema = v.array(HybridSearchItemSchema)
